<template>
    <svg :class="className" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.00192 6.70703L0.648362 1.35348L1.35547 0.64637L6.00192 5.29282L10.6484 0.646371L11.3555 1.35348L6.00192 6.70703Z"/>
    </svg>
</template>

<script>
export default {props: ['className']};
</script>
